import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-solicitacoes-cadastro',
  templateUrl: './solicitacoes-cadastro.component.html',
  styleUrls: ['./solicitacoes-cadastro.component.scss', '../../styles/estilo.padrao.scss']
})
export class SolicitacoesCadastroComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  solicitacaoCadastroForm: FormGroup;

  displayedColumns: string[] = ['Nome', 'Email', 'Telefone', 'CPFCNPJ', 'DataHoraSolicitacao', 'Cidade', 'sVisualizada', 'Consultar'];
  solicitacoesCadastroSource;
  $solicitacoes;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,

  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('solicitacoes-cadastro');
  }

  ngOnInit(): void {

    this.$solicitacoes = this.usuarioService.getSolicitacoesCadastro(this.uid).subscribe(snap => {
      this.solicitacoesCadastroSource = [];

      if (snap.length > 0) {
        let auxFornecedores: any[] = [];
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxFornecedores.push({
            ID: item.key,
            CNPJ: dados.CNPJ,
            CPF: dados.CPF,
            Email: dados.Email,
            Nome: dados.Nome,
            Observacao: dados.Observacao,
            Telefone: dados.Telefone,
            Timestamp: dados.Timestamp,
            TipoCadastro: dados.TipoCadastro,
            bVisualizada: dados.bVisualizada,
            sVisualizada: dados.bVisualizada ? 'Sim' : 'Não',
            CPFCNPJ: dados.TipoCadastro === 'CPF' ? dados.CPF : dados.CNPJ,
            DataHoraSolicitacao: this.usuarioService.tratarDataHora(dados.Timestamp),
            UF: dados.UF,
            Cidade: dados.Cidade
          });
        });

        auxFornecedores = auxFornecedores.reverse();

        // this.usuarioService.setLog("Consulta geral de solicitações cadastro", null, this.uid);

        this.solicitacoesCadastroSource = new MatTableDataSource(auxFornecedores);
        this.solicitacoesCadastroSource.paginator = this.paginator;

        setTimeout(() => this.spinner.hide('solicitacoes-cadastro'), 300);
      } else {
        this.toastr.error("Não foi possível localizar solicitações de cadastro!", 'Erro');
        setTimeout(() => this.spinner.hide('solicitacoes-cadastro'), 300);
      }
    });

    this.solicitacaoCadastroForm = this.formBuilder.group({
      id: ['', null],
      cnpj: ['', null],
      cpf: ['', null],
      email: ['', null],
      nome: ['', null],
      observacao: ['', null],
      telefone: ['', null],
      dataHoraSolicitacao: ['', null],
      tipoCadastro: ['', null],
      bVisualizada: [true, null],
      uf: ['', null],
      cidade: ['', null],
    });
  }

  ngOnDestroy() {
    this.$solicitacoes = null;
  }

  consultarSolicitacao(dados) {
    this.bConsulta = true;

    this.usuarioService.setLog("Consulta detalhada solicitação cadastro: " + dados.ID + ' Nome Fantasia: ' + dados.Nome, null, this.uid);

    this.solicitacaoCadastroForm.get('id').patchValue(dados.ID);
    this.solicitacaoCadastroForm.get('cnpj').patchValue(dados.CNPJ);
    this.solicitacaoCadastroForm.get('cpf').patchValue(dados.CPF);
    this.solicitacaoCadastroForm.get('email').patchValue(dados.Email);
    this.solicitacaoCadastroForm.get('nome').patchValue(dados.Nome);
    this.solicitacaoCadastroForm.get('observacao').patchValue(dados.Observacao);
    this.solicitacaoCadastroForm.get('dataHoraSolicitacao').patchValue(dados.DataHoraSolicitacao);
    this.solicitacaoCadastroForm.get('bVisualizada').patchValue(dados.bVisualizada);
    this.solicitacaoCadastroForm.get('tipoCadastro').patchValue(dados.TipoCadastro);
    this.solicitacaoCadastroForm.get('telefone').patchValue(dados.Telefone);
    this.solicitacaoCadastroForm.get('uf').patchValue(dados.UF);
    this.solicitacaoCadastroForm.get('cidade').patchValue(dados.Cidade);

    this.solicitacaoCadastroForm.get('id').disable();
    this.solicitacaoCadastroForm.get('cnpj').disable();
    this.solicitacaoCadastroForm.get('cpf').disable();
    this.solicitacaoCadastroForm.get('email').disable();
    this.solicitacaoCadastroForm.get('nome').disable();
    this.solicitacaoCadastroForm.get('observacao').disable();
    this.solicitacaoCadastroForm.get('dataHoraSolicitacao').disable();
    this.solicitacaoCadastroForm.get('telefone').disable();
    this.solicitacaoCadastroForm.get('uf').disable();
    this.solicitacaoCadastroForm.get('cidade').disable();
  }

  async atualizar() {
    this.spinner.show('default');

    if (this.solicitacaoCadastroForm.valid) {
      try {
        const resp = await this.usuarioService.updateSolicitacaoCadastro(this.uid, this.f.id.value);
        this.toastr.success('Solicitação marcada como vista!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

        this.usuarioService.setLog("Alteração da solicitação cadastro (VISTA): " + this.f.id.value + ' Nome: ' + this.f.nome.value, null, this.uid);

        setTimeout(() => {
          this.spinner.hide('default');
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/solicitacoes-cadastro"]));
          this.toastr.clear();
        }, 800);
      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro na solicitação de cadastro: " + this.f.id.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao atualizar solicitação de cadastro!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/solicitacoes-cadastro"]));
      }
    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.solicitacaoCadastroForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.solicitacoesCadastroSource.filter = filterValue.trim().toLowerCase();

    if (this.solicitacoesCadastroSource.paginator) {
      this.solicitacoesCadastroSource.paginator.firstPage();
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/solicitacoes-cadastro"]));
  }

  // convenience getter for easy access to form fields
  get f() { return this.solicitacaoCadastroForm.controls; }
}
